import { PayrollWorkspace } from '@/features/hr/payroll/PayrollWorkspace';

export function PayrollPage() {
  return <PayrollWorkspace />;
}
